"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserNotFoundError = exports.UserManager = void 0;
const static_partial_myid_users_1 = require("./static/static-partial-myid-users");
const user_1 = require("./user");
class UserManager {
    static findById(userId) {
        const myid = static_partial_myid_users_1.STATIC_PARTIAL_MYID_USERS.find(user => user['id.sapID'] === userId);
        if (!myid) {
            throw new UserNotFoundError(userId);
        }
        return new user_1.User(myid);
    }
    static listAllMyID() {
        return static_partial_myid_users_1.STATIC_PARTIAL_MYID_USERS;
    }
}
exports.UserManager = UserManager;
class UserNotFoundError extends Error {
    constructor(userId) {
        super(`No user with id "${userId}" found.`);
        this.userId = userId;
    }
}
exports.UserNotFoundError = UserNotFoundError;
//# sourceMappingURL=user-manager.js.map